import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/password";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";

export default function RegisterAccessView({
  goBack,
  onChange,
  submit,
  password,
  confirmPassword,
  isDisabled,
  validatesPassword,
  validatesConfirmPassword,
  isVisiblePassword,
  isVisibleConfirmPassword,
  toggleIsVisiblePassword,
  toggleIsVisibleConfirmPassword,
  isLoading,
  error,
  setError,
  success,
  setSuccess,
  goToLogin,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Senha"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Dados Pessoais</h2>
            <h3 className="text-black text-sm">Informe seus dados nos campos abaixo</h3>
            <div className="flex flex-col justify-center items-center">
              <div className="flex flex-col w-full mt-3 relative">
                <input 
                  value={password}
                  required 
                  onChange={onChange} 
                  type={isVisiblePassword ? "text" : "password"}
                  name="password" 
                  placeholder="Sua senha" 
                  className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <button type="button" onClick={toggleIsVisiblePassword} className="absolute right-2 top-5">
                  <img 
                    src={isVisiblePassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="mt-1 bg-white w-full rounded-md p-2">
                {validatesPassword?.map((item, index) => (
                  <div key={index} className="flex flex-row items-center justify-start">
                    <img 
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt="ícone sucesso"
                      className="mr-2"
                    />
                    <p className="text-sm text-gray-400">{item.text}</p>
                  </div>
                ))}
              </div>
              <div className="flex flex-col w-full mt-3 relative">
                <input 
                  value={confirmPassword}
                  required 
                  onChange={onChange} 
                  type={isVisibleConfirmPassword ? "text" : "password"}
                  name="confirmPassword" 
                  placeholder="Confirmar senha"
                  className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14" 
                />
                <button type="button" onClick={toggleIsVisibleConfirmPassword} className="absolute right-2 top-5">
                  <img 
                    src={isVisibleConfirmPassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="mt-1 bg-white w-full rounded-md p-2">
                {validatesConfirmPassword?.map((item, index) => (
                  <div key={index} className="flex flex-row items-center justify-start">
                    <img 
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt="ícone sucesso"
                      className="mr-2"
                    />
                    <p className="text-sm text-gray-400">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Button 
            title={"Avançar"}
            onClick={submit}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </main>
      {error && <Modal
        title="Ops!"
        message="Houve um problema ao trocar sua senha, quer tentar novamente?"
        actionMessage="Tentar novamente"
        action={submit}
        actionSecondMessage="Não!"
        actionSecond={() => setError(false)}
      />}
      {success && <Modal
        title="Muito bem"
        message="Senha alterada com sucesso"
        actionMessage="Fazer login"
        action={() => {
          setSuccess(false);
          goToLogin();
        }}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
